<i
  class="fas fa-circle rental-status"
  [ngClass]="rental?.status || 'ready'"
  [matTooltip]="(rental?.status | titleCase) || 'Ready'"
  matTooltipPosition="above"
  matTooltipClass="text-center"
></i>
